import { useExternalConnectionCalendars as _useExternalConnectionCalendars } from '@griply/hooks';
import { useExternalConnectionCalendarsQuery } from 'shared/hooks/queries/use-external-connection-calendars-query';
import { ID } from 'shared/types/id';

export const useExternalConnectionCalendars = (connectionId: ID) => {
  const { data, isLoading } = useExternalConnectionCalendarsQuery(connectionId);

  const { calendars } = _useExternalConnectionCalendars(
    data?.calendars,
    isLoading,
  );
  return calendars;
};
